export default "__VITE_ASSET__BbEdHgIB__"